import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { MastercardIcon } from "../../../Icons/Mastercard/Mastercard";

type Props = Omit<CardIconWrapperProps, "children">;

export const MastercardCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={MastercardIcon} />
    </CardIconWrapper>
  );
};
